/**
 * Public routes
 */
import RouterUtils from '@/utils/router';
import Login from '@/views/public/Login.vue';
import PasswordReset from '@/views/public/password-reset/PasswordReset.vue';
import SetNewPassword from '@/views/public/password-reset/SetNewPassword.vue';
import Confirmation from '@/views/public/registration/Confirmation.vue';
import Registration from '@/views/public/registration/RegistrationPage.vue';

export default [
  {
    path: '/registration',
    name: 'registration',
    component: Registration,
    beforeEnter: [RouterUtils.checkAnonymousUser],
  },
  {
    path: '/confirm/:fid/:token',
    name: 'confirm',
    component: Confirmation,
    beforeEnter: [RouterUtils.checkAnonymousUser],
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    beforeEnter: [RouterUtils.checkAnonymousUser],
  },
  {
    path: '/password-reset',
    name: 'PasswordReset',
    component: PasswordReset,
    beforeEnter: [RouterUtils.checkAnonymousUser],
  },
  {
    path: '/password-reset/new-password/:resetToken',
    name: 'SetNewPassword',
    component: SetNewPassword,
    beforeEnter: [RouterUtils.checkAnonymousUser],
  },
];
